import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReferencesComponent } from './components/references/references.component';
import { ContractManagementComponent } from './components/contract-management/contract-management.component';
import { ConstructionMaintenanceComponent } from './components/construction-maintenance/construction-maintenance.component';
import { AccreditationKuwaitComponent } from './components/accreditation-kuwait/accreditation-kuwait.component';
import { AccreditationUaeComponent } from './components/accreditation-uae/accreditation-uae.component';
import { CustomerfocusRiskmanagementComponent } from './components/customerfocus-riskmanagement/customerfocus-riskmanagement.component';
import { HseMarketingDocumetsComponent } from './components/hse-marketing-documets/hse-marketing-documets.component';
import { InforDocumentsComponent } from './components/infor-documents/infor-documents.component';
import { QHSEComponent } from './components/qhse/qhse.component';
import { QHSEdocumentsPAHWS2Component } from './components/qhsedocuments-pahws2/qhsedocuments-pahws2.component';
import { ServicesPropertyMgmtComponent } from './components/services-property-mgmt/services-property-mgmt.component';
import { VendorContractSopComponent } from './components/vendor-contract-sop/vendor-contract-sop.component';
import { WorkforceplanningResourceProcessComponent } from './components/workforceplanning-resource-process/workforceplanning-resource-process.component';
import { EnvironmentalManagementComponent } from './components/environmental-management/environmental-management.component';
import { HealthSafetyComponent } from './components/health-safety/health-safety.component';
import { QualityManagementComponent } from './components/quality-management/quality-management.component';
import { ReferenceCategoryComponent } from './components/reference-category/reference-category.component';

const routes: Routes = [
  { path: '', redirectTo: 'tiles', pathMatch: 'full' },
  { path: 'tiles', component: ReferencesComponent },
  { path: 'category', component: ReferenceCategoryComponent },
  { path: 'contract-management', component: ContractManagementComponent, },
  { path: 'construction-maintenance', component: ConstructionMaintenanceComponent, },
  { path: 'customerfocus-Riskmanagement', component: CustomerfocusRiskmanagementComponent, },
  { path: 'hseMarketingDocumets', component: HseMarketingDocumetsComponent, },
  { path: 'inforDocuments', component: InforDocumentsComponent, },
  { path: 'qhse', component: QHSEComponent, },
  { path: 'documentsPAHWS2', component: QHSEdocumentsPAHWS2Component, },
  { path: 'servicesProperty', component: ServicesPropertyMgmtComponent, },
  { path: 'vendorContractSop', component: VendorContractSopComponent, },
  { path: 'workforceplanningResource', component: WorkforceplanningResourceProcessComponent, },
  { path: 'accreditationKuwait', component: AccreditationKuwaitComponent, },
  { path: 'accreditationUae', component: AccreditationUaeComponent, },
  { path: 'EnvironmentalManagement', component: EnvironmentalManagementComponent, },
  { path: 'HealthSafety', component: HealthSafetyComponent, },
  { path: 'QualityManagement', component: QualityManagementComponent, },
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReferenceRoutingModule { }
